module.exports = __webpack_public_path__ + "img/ponto-logo.fd06520a.png";